export default "__VITE_ASSET__CVGoQavq__"